<template>
  <div class="form-group">
    <label class="form-label">{{ titel }}</label>
    <input
      class="form-control"
      type="text"
      @input="
        $parent.$emit('filter-update', { value: $event.target.value, name })
      "
    />
  </div>
</template>

<script>
export default {
  props: {
    titel: {
      type: String,
      default: "ID"
    },
    name: {
      type: String,
      required: true
    }
  }
};
</script>
